import {Map} from "immutable";
import {validatePresence, validateIncludes} from "./Validators";
import {getUSStates, getCanadaProvinces, isUS, isCanada} from "./CountriesAndStates";
import {hasStateProvince} from "./AddressRules";

function validateAddress(values, errors) {
  errors = validatePresence(errors, values, "name");
  errors = validatePresence(errors, values, "addressCountryCode");
  errors = validatePresence(errors, values, "addressAddressLine1");
  errors = validatePresence(errors, values, "addressCity");
  if (isUS(values.get("addressCountryCode"))) {
    let usStates = getUSStates().map(x => x.get("code"));
    errors = validateIncludes(errors, values, "addressStateProvince", usStates);
  } else if (hasStateProvince(values.get("addressCountryCode"))) {
    errors = validatePresence(errors, values, "addressStateProvince");
  }
  if (isCanada(values.get("addressCountryCode"))) {
    let caProvinces = getCanadaProvinces().map(x => x.get("code"));
    errors = validateIncludes(errors, values, "addressStateProvince", caProvinces);
  } else if (hasStateProvince(values.get("addressCountryCode"))) {
    errors = validatePresence(errors, values, "addressStateProvince");
  }
  errors = validatePresence(errors, values, "addressPostcode");
  return errors;  
}

export function validateShippingAddress(values, errors=Map()) {
  errors = validatePresence(errors, values, "type");
  return validateAddress(values, errors);
}

export function validateBillingAddress(values, errors=Map()) {
  return validateAddress(values, errors);
}